import { date } from 'quasar'

export default (val, format) => date.formatDate(val, format)
